// extracted by mini-css-extract-plugin
module.exports = {"root":"nKUtODlt","small":"gk1FaZwe","medium":"pZW9ANcb","large":"q19CFc7K"};